export const NAVIGATION = 'NAVIGATION'
export const HEADER = 'HEADER'
export const BROWSE = 'BROWSE'
export const DESIGN = 'DESIGN'
